export var MOBIUS_SOCKET_MESSAGE_TYPE;
(function (MOBIUS_SOCKET_MESSAGE_TYPE) {
    MOBIUS_SOCKET_MESSAGE_TYPE["UNKNOWN"] = "UNKNOWN";
    MOBIUS_SOCKET_MESSAGE_TYPE["REGISTER"] = "register";
    MOBIUS_SOCKET_MESSAGE_TYPE["REGISTER_RESPONSE"] = "register.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["UNREGISTER"] = "unregister";
    MOBIUS_SOCKET_MESSAGE_TYPE["UNREGISTER_RESPONSE"] = "unregister.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_STATUS"] = "device_status";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_STATUS_RESPONSE"] = "device_status.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_GET"] = "device_get";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_GET_RESPONSE"] = "device_get.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_LIST"] = "device_list";
    MOBIUS_SOCKET_MESSAGE_TYPE["DEVICE_LIST_RESPONSE"] = "device_list.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_SETUP"] = "call_setup";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_SETUP_RESPONSE"] = "call_setup.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_STATE"] = "call_state";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_STATE_RESPONSE"] = "call_state.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_STATUS"] = "call_status";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_STATUS_RESPONSE"] = "call_status.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_MEDIA"] = "call_media";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_MEDIA_RESPONSE"] = "call_media.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_HOLD"] = "call_hold";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_HOLD_RESPONSE"] = "call_hold.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_RESUME"] = "call_resume";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_RESUME_RESPONSE"] = "call_resume.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_TRANSFER"] = "call_transfer";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_TRANSFER_RESPONSE"] = "call_transfer.response";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_DELETE"] = "call_delete";
    MOBIUS_SOCKET_MESSAGE_TYPE["CALL_DELETE_RESPONSE"] = "call_delete.response";
})(MOBIUS_SOCKET_MESSAGE_TYPE || (MOBIUS_SOCKET_MESSAGE_TYPE = {}));
